module.exports = __webpack_public_path__ + "img/bg-service-item.a3e61d96.png";